<template>
  <div id="benchmarking">
    <Header />
    <div class="container_width">
      <div class="sansation_title pg_title_color mt-6 mb-10">
        Benchmarking Tools
      </div>

      <!-- <v-alert
          icon="mdi-bullhorn-variant"
          elevation="2"
          border="right"
          type="info"
          text
          outlined
          prominent
          class="ma-6 py-6 sansation_subtitle font-weight-medium"> 
          We&apos;re working to improve our deliverability of this service ... please stay tuned for more in the near future!
      </v-alert> -->

      <div v-if="loading" class="text-center py-12" style="width: 100%">
        <v-progress-circular
          indeterminate
          color="primary"
          class="my-12"
          size="80"
          width="4"
        ></v-progress-circular>
      </div>

      <div 
        ref="tableau" 
        class="tableau-wrapper"
        :style="{ opacity: loading ? 0 : 1 }">
      </div>
    </div>
  </div>
</template>

<script>
import debounce from '@/lib/debounce'
import Header from "./Header";

export default {
  name: "Benchmarking",
  components: {
    Header,
  },

  data () {
    return {
      loading: true,

      viz: null,
      // url: "https://public.tableau.com/views/MyCompassDashboard-1/ValuationDataaGlance2", // VIA KIT
      // url: "https://public.tableau.com/views/June2022MyCompassData/ValuationData", // VIA KATIE
      url: "https://public.tableau.com/views/MyCompassDashboard/ValuationData",
      options: {
        embed_code_version: 3,
        site_root: "",
        // name: "MyCompassDashboard-1/ValuationDataaGlance2",
        // name: "June2022MyCompassData/ValuationData",
        name: "MyCompassDashboard/ValuationData",
        hideTabs: false,
        hideToolbar: true,
        showAppBanner: false,

        onFirstInteractive: () => {
          this.loading = false
        },
      },

      debouncedResize: () => {},
    };
  },

  created () {
      document.title = 'SRG myCompass: Benchmarking Tools'
  },

  mounted () {
    this.resizeViz(false)
    this.initViz()

    this.debouncedResize = debounce(this.resizeViz)
    window.addEventListener('resize', this.debouncedResize)
  },

  destroyed () {
    window.removeEventListener('resize', this.debouncedResize)

    if (this.viz) this.viz.dispose()
  },

  methods: {
    async initViz () {
      this.loading = true
      this.viz = new window.tableau.Viz(this.$refs.tableau, this.url, this.options)
    },

    resizeViz (createVizOnResize = true) {
      const newDeviceSize = this.$refs.tableau.offsetWidth > 800 
        ? 'desktop' 
        : 'phone'

      if (newDeviceSize === this.options.device) return

      this.options.device = newDeviceSize

      if (newDeviceSize === 'desktop') {
        this.options.width = '1280px'
        this.options.height = '1600px'
      }

      if (newDeviceSize === 'phone') {
        this.options.width = '100%'
        this.options.height = '3000px'
      }

      if (createVizOnResize && this.viz) {
        this.viz.dispose()
        this.initViz()
      }
    },
  },
};
</script>


<style scoped>
a.button_link {
  text-decoration-line: none;
}

#benchmarking {
  min-height: 60vh;
}

.tableau-wrapper {
  width: 100%; 
  overflow-x: auto;

  transition: 0.5s ease-in-out;
  margin-bottom: 5%;
}

.green-box-img {
  transform: translateY(12px);
  margin-right: 10px;
  width: 40px;
  height: 40px;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/Benchmarking.vue